

import { useAuth } from "react-oidc-context";

const Home = () => {

    const auth = useAuth();
    return (
        <div>
            {(auth.isAuthenticated) ?
                <div>

                    <h1>Dobrý deň {auth.user?.profile.preferred_username}   ({auth.user?.profile.email})</h1>

                    <p> Táto stránka vám umožní zmeniť si heslo na prístup do fakultných služieb, pevnej siete fakulty a wifi siete fakulty.  <b>Neodporúčame realizovať zmenu hesla na verejných počítačoch alebo použiť rovnaké heslo ako máte v AIS.</b></p>
                    <ul>
                        <li><b>1. Heslo do služieb fakulty.</b> Heslo slúži pre prístup do všetkých fakultných služieb, pevnej siete fakulty, wifi siete fakulty a služieb poskytovaných knižnicou. Zoznam služieb nájdete na <a target="_blank" href={"https://support.fchpt.stuba.sk/helpdesk/kb/faq.php?id=49"}> support.fchpt.stuba.sk </a> </li>
                    </ul>

                    <p><b>Pre zmenu hesla postupujte nasledovne: </b></p>

                    <ul>
                        <li>Zmeňte si heslá kliknutím na "Change Passwords" v menu vľavo.</li>
                        <li>Upozornenie: Zmena hesla môže trvať niekoľko sekúnd. Heslo je úspešne zmenené až keď vám aplikácia oznámi "Password changed successfully". V prípade chyby kontaktujte správcu.</li>
                        <li><b>Odhláste sa a ak ste na verejnom počítači ukončite prezerač, inak hrozí zneužitie vašich prístupov</b></li>

                    </ul>

                    <p><b>Pomoc  - detailné informácie nájdete na <a target="_blank" href={"https://support.fchpt.stuba.sk/helpdesk/kb/faq.php?id=48"}> support.fchpt.stuba.sk </a></b></p>

                    <p><b>Kontakt  mailom na <a target="_blank" href={"mailto:support@fchpt.stuba.sk"}> support@fchpt.stuba.sk </a> alebo  <a target="_blank" href={"https://support.fchpt.stuba.sk/helpdesk/open.php"}>formulárom</a>.</b></p>

                    <br></br>

                </div>

                :

                <>
                    <p> <b> Táto stranka vám umožní zmeniť si heslo na prístup do fakultných služieb , pevnej siete fakulty, wifi siete fakulty a služieb knižnice. Pre zmenu hesla postupujte nasledovne: </b></p>

                        <ul>
                            <li>1. Prihláste sa vašim AIS kontom a AIS heslom v tvare uid napr. "jankop" alebo univerzitným mailom vo forme jankop@stuba.sk tlačidlom <b>Log In</b> vľavo. </li>
                            <li>2. Postupujte podľa informácií poskytnutých po prihlásení. </li>
                    </ul>
                    <p><b>Pomoc  - detailné informácie nájdete na <a target="_blank"  href={"https://support.fchpt.stuba.sk/helpdesk/kb/faq.php?id=48"}> support.fchpt.stuba.sk </a></b></p>
                    <p><b>Kontakt  mailom na <a target="_blank" href={"mailto:support@fchpt.stuba.sk"}> support@fchpt.stuba.sk </a> alebo  <a target="_blank" href={"https://support.fchpt.stuba.sk/helpdesk/open.php"}>formulárom</a>.</b></p>


                </>
            }



        </div>
    );
};

export default Home;
